

















import { Component, Vue } from "vue-property-decorator";
import { Collection, Document, Participant, Room, QueuedSong } from "@/types";

import InstructionsBox from "@/components/InstructionsBox.vue";
import SideBar from "@/components/room/SideBar.vue";
import VideoPlayer from "@/components/room/VideoPlayer.vue";
import PracticeBar from "@/components/PracticeBar.vue";

import { db, functions } from "@/firebase";

type PracticeData = {
  room: Document<Room>;
  songqueue: Collection<QueuedSong>;
  participants: Collection<Participant>;
  me: Document<Participant>;
};

@Component({
  components: {
    PracticeBar,
    SideBar,
    InstructionsBox,
    VideoPlayer,
  },
})
export default class PracticeView extends Vue {
  data: PracticeData | null = null;
  room: Document<Room> | null = null;
  participants: Collection<Participant> | null = null;
  songqueue: Collection<QueuedSong> | null = null;
  me: Document<Participant> | null = null;
  // @ts-ignore: webkitAudioContext is not known
  audioCtx = new (window.AudioContext || window.webkitAudioContext)();

  unsubscribes: { (): void }[] = [];

  async created() {
    this.$store.commit("setLoading");
    const res = await functions.httpsCallable("practiceRoom")();

    this.room = { data: null, ref: null };
    this.$set(this.room, "ref", db.collection("practice").doc(res.data.id));
    await this.$bind("room.data", this.room.ref);

    this.participants = { data: null, ref: null };
    this.$set(this.participants, "ref", this.room.ref.collection("participants"));
    await this.$bind("participants.data", this.participants.ref);

    this.me = { data: null, ref: null };
    this.$set(this.me, "ref", this.participants.ref.doc(this.$store.state.user.data.uid));
    const styleNum = Math.floor(Math.random() * 15) + 1;
    const profilePic = this.$store.state.user.data.photoURL;
    await this.me.ref.set(
      { name: this.$store.state.user.data.displayName, style: "p" + styleNum, profilePic: profilePic },
      { merge: true },
    );
    await this.$bind("me.data", this.me.ref);

    this.songqueue = { data: null, ref: null };
    this.$set(this.songqueue, "ref", this.room.ref.collection("songqueue"));
    await this.$bind("songqueue.data", this.songqueue.ref.orderBy("added"));

    this.data = {
      room: this.room,
      songqueue: this.songqueue,
      me: this.me,
      participants: this.participants,
    };
    this.$store.commit("setNotLoading");
  }

  get myId() {
    return this.$store.state.user.data.uid;
  }

  role(participantId: string) {
    if (this.isMe(participantId)) {
      return "me";
    }
    if (this.myId < participantId) {
      return "rude";
    }
    return "polite";
  }

  isMe(participantId: string) {
    return this.myId === participantId;
  }

  get currentSong() {
    return this.data.room.data.currentSong || this.data.room.data.onDeck;
  }

  get currentSongUrl() {
    if (this.data.room.data.currentSong) {
      return this.data.room.data.currentSong.url;
    } else {
      return null;
    }
  }

  beforeDestroy() {
    this.unsubscribes.forEach(f => f());
  }
}
